// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FeedbackForm.css */
/* body {
    background: 
    url('../../Assets/Dabur_tree.png') no-repeat center center fixed, 
    linear-gradient(25.7263deg, #111a23 0%, #496c58 63.96%, #a9cbaa 100%);
    font-family: 'Arial', sans-srif;
} */

body {
  background: linear-gradient(25.7263deg, #111a23 0%, #496c58 63.96%, #a9cbaa 100%);
  background-attachment: fixed;
  font-family: 'Roboto', sans-serif;
  position: relative;
}

body::before {
  content: "";
  position: absolute;
  top: 0;
  left: -40%; /* Adjust left position to move image more to the left */
  width: 90%; /* Adjust width to control truncation */
  height: 100%;
  /* background: url("../../Assets/Dabur_tree.png") no-repeat left center; */
  background-size: cover; /* Adjust size to cover the container */
  z-index: -1; /* Place it behind other content */
}

.form-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 15px;
  flex-direction: column;
}

.feedback-form {
  background: rgba(255, 255, 255, 0.334);
  border-radius: 15px;
  padding: 30px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
}

.form-title {
  text-align: center;
  color: #004713;
  /* margin-bottom: 20px; */
  font-size: 1.5rem;
}

.form-group {
  margin-bottom: 1rem;
  position: relative;
}

.form-control {
  border-radius: 10px;
  border: 1px solid #ced4da;
  padding: 10px;
  width: 100%;
}

textarea.form-control {
  resize: none;
  height: 100px;
}

.voice-input-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 1.2rem;
  color: #6c757d;
}

.voice-input-btn:hover {
  color: #495057;
}

.thankyou-message {
  font-size: 18px;
  text-align: center;
  margin-bottom: 20px;
  color: white;
}

.next-steps {
  font-size: 16px;
  text-align: center;
  color: white;
}

.tick-icon-container {
  display: flex;
  justify-content: center;
  /* margin-bottom: 20px; */
}

.tick-icon {
  width: 50px;
  height: 50px;
  stroke-width: 3;
}

.submit-btn {
  display: block;
  width: 100%;
  background-color: #004713;
  color: white;
  padding: 10px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 1rem;
}

.submit-btn:hover {
  background-color: #f37021;
}

.icon {
  font-size: 2rem; 
  color: #6c757d; 
  display: flex;
  align-items: center;
}

.input-group-text {
  height: 100%;
  color: grey;
  background-color: white;
  padding: 10px;
  border-radius: 10px 0 0 10px;

}

/* .form-group-container {
  height: 40vh;
  overflow-y: auto;
  margin-bottom: 10px;
} */

.input-group-prepend {
  background-color: white;
  border-radius: 10px 0 0 10px;
}

@media screen and (max-width: 768px) {
  body::before {
    left: -10%; 
    width: 100%; 
    background-size: auto; 
    background-position: center;
    /* background: url("../../Assets/Dabur_tree_small.png") no-repeat left center; */
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/FeedbackForm/FeedbackForm.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;;;;;GAKG;;AAEH;EACE,iFAAiF;EACjF,4BAA4B;EAC5B,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU,EAAE,wDAAwD;EACpE,UAAU,EAAE,uCAAuC;EACnD,YAAY;EACZ,0EAA0E;EAC1E,sBAAsB,EAAE,uCAAuC;EAC/D,WAAW,EAAE,kCAAkC;AACjD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,4BAA4B;;AAE9B;;AAEA;;;;GAIG;;AAEH;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,2BAA2B;IAC3B,gFAAgF;EAClF;AACF","sourcesContent":["/* FeedbackForm.css */\r\n/* body {\r\n    background: \r\n    url('../../Assets/Dabur_tree.png') no-repeat center center fixed, \r\n    linear-gradient(25.7263deg, #111a23 0%, #496c58 63.96%, #a9cbaa 100%);\r\n    font-family: 'Arial', sans-srif;\r\n} */\r\n\r\nbody {\r\n  background: linear-gradient(25.7263deg, #111a23 0%, #496c58 63.96%, #a9cbaa 100%);\r\n  background-attachment: fixed;\r\n  font-family: 'Roboto', sans-serif;\r\n  position: relative;\r\n}\r\n\r\nbody::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0;\r\n  left: -40%; /* Adjust left position to move image more to the left */\r\n  width: 90%; /* Adjust width to control truncation */\r\n  height: 100%;\r\n  /* background: url(\"../../Assets/Dabur_tree.png\") no-repeat left center; */\r\n  background-size: cover; /* Adjust size to cover the container */\r\n  z-index: -1; /* Place it behind other content */\r\n}\r\n\r\n.form-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 100vh;\r\n  padding: 15px;\r\n  flex-direction: column;\r\n}\r\n\r\n.feedback-form {\r\n  background: rgba(255, 255, 255, 0.334);\r\n  border-radius: 15px;\r\n  padding: 30px;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n  width: 100%;\r\n  max-width: 400px;\r\n}\r\n\r\n.form-title {\r\n  text-align: center;\r\n  color: #004713;\r\n  /* margin-bottom: 20px; */\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.form-group {\r\n  margin-bottom: 1rem;\r\n  position: relative;\r\n}\r\n\r\n.form-control {\r\n  border-radius: 10px;\r\n  border: 1px solid #ced4da;\r\n  padding: 10px;\r\n  width: 100%;\r\n}\r\n\r\ntextarea.form-control {\r\n  resize: none;\r\n  height: 100px;\r\n}\r\n\r\n.voice-input-btn {\r\n  position: absolute;\r\n  top: 5px;\r\n  right: 5px;\r\n  border: none;\r\n  background: transparent;\r\n  cursor: pointer;\r\n  font-size: 1.2rem;\r\n  color: #6c757d;\r\n}\r\n\r\n.voice-input-btn:hover {\r\n  color: #495057;\r\n}\r\n\r\n.thankyou-message {\r\n  font-size: 18px;\r\n  text-align: center;\r\n  margin-bottom: 20px;\r\n  color: white;\r\n}\r\n\r\n.next-steps {\r\n  font-size: 16px;\r\n  text-align: center;\r\n  color: white;\r\n}\r\n\r\n.tick-icon-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  /* margin-bottom: 20px; */\r\n}\r\n\r\n.tick-icon {\r\n  width: 50px;\r\n  height: 50px;\r\n  stroke-width: 3;\r\n}\r\n\r\n.submit-btn {\r\n  display: block;\r\n  width: 100%;\r\n  background-color: #004713;\r\n  color: white;\r\n  padding: 10px;\r\n  border: none;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  font-size: 1rem;\r\n}\r\n\r\n.submit-btn:hover {\r\n  background-color: #f37021;\r\n}\r\n\r\n.icon {\r\n  font-size: 2rem; \r\n  color: #6c757d; \r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.input-group-text {\r\n  height: 100%;\r\n  color: grey;\r\n  background-color: white;\r\n  padding: 10px;\r\n  border-radius: 10px 0 0 10px;\r\n\r\n}\r\n\r\n/* .form-group-container {\r\n  height: 40vh;\r\n  overflow-y: auto;\r\n  margin-bottom: 10px;\r\n} */\r\n\r\n.input-group-prepend {\r\n  background-color: white;\r\n  border-radius: 10px 0 0 10px;\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  body::before {\r\n    left: -10%; \r\n    width: 100%; \r\n    background-size: auto; \r\n    background-position: center;\r\n    /* background: url(\"../../Assets/Dabur_tree_small.png\") no-repeat left center; */\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
